var _a;
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import WeekStartersEnum from '../../../../enums/WeekStartersEnum';
import ScreenReaderOnly from '../../ScreenReaderOnly/ScreenReaderOnly';
import { st, classes } from './MonthlyHeaders.st.css';
import capitalize from '../../../../utils/stringUtils';
import { getWeekDaysByWeekStarter } from '../../../../utils/momentUtils';
var weekDaysGetter = (_a = {},
    _a[WeekStartersEnum.Sunday] = function (t, locale) {
        return getWeekDaysByWeekStarter(0, t, locale);
    },
    _a[WeekStartersEnum.Monday] = function (t, locale) {
        return getWeekDaysByWeekStarter(1, t, locale);
    },
    _a[WeekStartersEnum.Saturday] = function (t, locale) {
        return getWeekDaysByWeekStarter(-1, t, locale);
    },
    _a);
// localeToggle isn't a used, but still a dependency
// in order to re-render with React.memo
// when locale changes
var MonthlyHeaders = function (_a) {
    var weekStarter = _a.weekStarter, localeToggle = _a.localeToggle, alignment = _a.alignment, isMobile = _a.isMobile, locale = _a.locale;
    var t = useTranslation()[0];
    var _b = weekDaysGetter[weekStarter](t, locale), weekDays = _b.weekDays, screenReaderDays = _b.screenReaderDays;
    return weekDays.map(function (day) { return (React.createElement("th", { key: day, className: st(classes.root, { alignment: alignment, isMobile: isMobile }) },
        React.createElement("span", { "aria-hidden": true }, capitalize(day, isMobile)),
        React.createElement(ScreenReaderOnly, null, screenReaderDays[day]))); });
};
export default React.memo(MonthlyHeaders);
//# sourceMappingURL=MonthlyHeaders.js.map